import * as React from 'react';
import { connect } from 'react-redux';
import { flatMap } from 'lodash';

import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformance, IPackage } from '../../custom/classes/production';
import ListPackageView from '../../views/library/list-package.view';
import { IPackageListingAppSettings } from '../../custom/classes/package-listing-settings';
import { toggleMiniCart, selectPackage, removeItemFromCart, disablePerformanceButtons } from '../../redux-state/actions/package-listing.actions';

import { RevealPanel } from '../../../../Static/javascript/Content/modules/revealPanel';
import { getAllPackagePerformances } from '../../helpers/performances-selectors';
import { AlternateCartItemType } from '../../classes/package-listing';
import { getCartItemDetails } from '../../helpers/cart-helpers';
interface IListPackageExternalProps {
    package: IPackage;
}

interface StateToProps {
    text: IPackageListingAppText;
    settings: IPackageListingAppSettings;
    selectedPackage: boolean;
    alternatePackageSelected: boolean;
    selectedPackageId: number;
    matchesCurrentRenewalPackage: boolean;
    filterFunction: (option) => any;
    numberOfPackagesInList: number;
    defaultPackageImageUrl: string;
    useUnseatedReserve: boolean;
    showSelectButton: boolean;
    reachedMaxQuantity: boolean;
    disableSeriesButtons: boolean;
}

interface DispatchToProps {
    selectPackage: (pkg: IPackage, unseated: boolean, isFixed: boolean) => void;
    removeFromCart: (itemId: number) => void;
    removeItemFromCart: (itemId: number, isAlternate?: boolean) => void;
    disableAllSeries: (isDisabled: boolean) => void;
}

interface ListPackageViewState {
    showPerformances: boolean;

}

interface ViewProps {
    toggleShowPerformances: (e) => void;
    packagePerformances: Array<IPerformance>;
    showPackage: boolean;

}

export type ListPackageProps = IListPackageExternalProps & StateToProps & DispatchToProps;

export type CombinedPackageViewProps = ListPackageProps & ListPackageViewState & ViewProps;

export class ListPackageBase extends React.Component<ListPackageProps, ListPackageViewState, any> {

    constructor(props: ListPackageProps) {
        super(props);
    }

    render() {
        const allPerf = getAllPackagePerformances(this.props.package);
        const filteredPerformances = allPerf.filter(this.props.filterFunction);

        const showPackage = filteredPerformances.length > 0;
        if (showPackage) {
            allPerf.forEach(perf => {
                perf.IsDroppable = this.props.package.droppableProductions &&
                    (this.props.package.droppableProductions.indexOf(perf.productionSeasonId) >= 0);
            })
        }

        return (
            <ListPackageView
                {...this.props}
                {...this.state}
                showPackage={showPackage}
                packagePerformances={allPerf}
                toggleShowPerformances={this._toggleShowPerformances.bind(this)}
            />
        )
    }

    _toggleShowPerformances = (e: MouseEvent) => {
        this.setState(
            { showPerformances: !(this.state.showPerformances) }
        );
    }

    componentDidMount() {
        const revealPanelEls = [].slice.call(document.querySelectorAll('[data-subs-panel]')) as Array<HTMLElement>;
        revealPanelEls.forEach(panelEl => { 
            new RevealPanel(panelEl.id);
        });
    }

}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListPackageExternalProps): StateToProps {
    const isRenewalAndHasReachedMaxQuantity = state.packageListingSettings.isRenewal
        && state.packageListing.cartItems.length === 1
        && ((state.packageListing.cartItems[0].selectedAlternateItem?.cartItemId ?? 0) > 0
            || state.packageListing.cartItems[0].selectedAlternateItem?.type === AlternateCartItemType.ZONE);

    // Check for selected package and a selected alternate item
    const reachedMaxQuantity = state.packageListing.cartItems.length === 1
        && ((state.packageListing.cartItems[0].selectedAlternateItem?.cartItemId ?? 0) > 0
            || state.packageListing.cartItems[0].selectedAlternateItem?.type === AlternateCartItemType.ZONE);

    // If a second choice is selected, filter items if it matches a cart item
    const alternatePackageSelected = state.packageListing.cartItems.length === 1 && state.packageListing.cartItems[0]?.selectedAlternateItem?.cartItemId == ownProps.package.id;
    // Get First Choice Package ID so the alternate cart removal can occur 
    const selectedPackageId = state.packageListing.cartItems.length === 1 ? state.packageListing.cartItems[0].cartItemId : 0;

    return {
        text: state.packageListingText,
        settings: state.packageListingSettings,
        selectedPackage: state.packageListing.cartItems.length > 0
            && state.packageListing.cartItems
            .filter(cartItem => cartItem.cartItemId == ownProps.package.id).length > 0,
        selectedPackageId: selectedPackageId,
        alternatePackageSelected: alternatePackageSelected,
        matchesCurrentRenewalPackage: state.packageListingSettings.currentRenewalPackageId === ownProps.package.id,
        filterFunction: state.packageListing.filterFunction,
        numberOfPackagesInList: state.packageListing.packages.length,
        defaultPackageImageUrl: state.packageListingSettings.defaultPackageImageUrl,
        useUnseatedReserve: state.packageListingSettings.useUnseatedReservation,
        showSelectButton: !isRenewalAndHasReachedMaxQuantity,
        reachedMaxQuantity: reachedMaxQuantity,
        disableSeriesButtons: state.packageListing.disableAllSeriesButtons
    }
}

function mapDispatchToProps(dispatch, ownProps: ListPackageProps): DispatchToProps {
    return {
        selectPackage: (pkg: IPackage, unseated: boolean, isFixed: boolean, goDirectlyToSmartSeat: boolean = false) => {
            if (goDirectlyToSmartSeat) {
                window.location.href = `${window["pageData"].smartSeatUrl}?itemNumber=${pkg.id}`;
            } else {
                dispatch(selectPackage(pkg, isFixed, unseated));
            }
            dispatch(toggleMiniCart(true));
        },
        removeFromCart: (itemId: number) => {
            dispatch(removeItemFromCart(itemId));
        },
        disableAllSeries: (isDisabled: boolean) => {
            dispatch(disablePerformanceButtons(isDisabled ?? false))
        },
         removeItemFromCart: (itemId: number, isAlternate?: boolean) => {
             dispatch(removeItemFromCart(itemId, isAlternate ?? false));
        },
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListPackageBase);